// import React from 'react';
// import { CirclePie } from 'salad-ui.chart';
// // import { Container } from 'mdbreact';
// import { Chart } from 'react-chartjs-2';
// import '../css/PieChart.css';
// import totalDevices from '../assets/images/totalDevices.svg';


// // custom pichart page to show data in chart format
// class PieChartNew extends React.Component {
//     constructor(props) {
//         super(props);    
//         this.state = {
//           labelFontSize: this.props.percentLabelSize || '1rem',
//           percentFontSize: this.props.percentFontSize || '4rem',
//           percentTop : this.props.percentTop || "24%",
//           percentLabelTop : this.props.percentLabelTop || "62%"
//         };
//       }
//     componentDidMount() {
//         //doughnut
//         var ctxD = document.getElementById("doughnutChart").getContext('2d');
//         new Chart(ctxD, {
//             type: 'doughnut',
//             data: {
//                 labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
//                 datasets: [
//                     {
//                         data: [300, 50, 100, 40, 120],
//                         backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
//                         hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
//                     }
//                 ]
//             },
//             options: {
//                 responsive: true
//             }
//         });
//     }
//     render() {
//         return (
//             <div className="text-center alignCircleItems" style={{paddingLeft: '0px', paddingRight: '0px', width: 'fit-content'}}>
//             <div className="alignDisplayOverCircle" style={{width: 'fit-content'}}>
//              <CirclePie strokeWidth={this.props.strokeWidth || 8} percent={this.props.percent} width={this.props.chartWidth} height={this.props.chartWidth} 
//              strokeColor={this.props.strokeColor || "#43425d" } label="asd" stroke={"red"}  />              
//              <div className="displayCircle" style={{top: this.state.percentTop}}>
//              <span className="some-text" style={{backgroundColor: this.props.displayBackgroundColor, fontSize: this.state.percentFontSize ,fontWeight: this.props.fontWeight || ''}}>
//              {this.props.percent}
//              </span>
//              </div>
//              <div className="displayCircleSubHeading text-center" style={{fontSize: this.state.labelFontSize, top: this.state.percentLabelTop, fontWeight: 'lighter' }}>{this.props.percentLabel}</div>
//              </div>          
//              <h6 className="mt-2">
//              {this.props.icon}
//              <div className="text-center mt-2" style={{color: '#43425D', fontSize: '.8rem'}}>{this.props.label}</div>    
//              </h6>        
//         </div>
//         );
//     }

// };

// export default PieChartNew;



import React from 'react';
import { Chart, DoughnutController, ArcElement, Tooltip, Legend, CategoryScale } from 'chart.js';
import { CirclePie } from 'salad-ui.chart';
import '../css/PieChart.css';
import totalDevices from '../assets/images/totalDevices.svg';

// Register necessary chart.js components
Chart.register(DoughnutController, ArcElement, Tooltip, Legend, CategoryScale);

class PieChartNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labelFontSize: props.percentLabelSize || '1rem',
      percentFontSize: props.percentFontSize || '4rem',
      percentTop: props.percentTop || '24%',
      percentLabelTop: props.percentLabelTop || '62%',
    };
    // this.chartRef = React.createRef();
  }

  componentDidMount() {
    // const ctx = this.chartRef.current.getContext('2d');
    // this.chartInstance = new Chart(ctx, {
    //   type: 'doughnut',
    //   data: {
    //     labels: ['Red', 'Green', 'Yellow', 'Grey', 'Dark Grey'],
    //     datasets: [
    //       {
    //         data: [300, 50, 100, 40, 120],
    //         backgroundColor: ['#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'],
    //         hoverBackgroundColor: ['#FF5A5E', '#5AD3D1', '#FFC870', '#A8B3C5', '#616774'],
    //       },
    //     ],
    //   },
    //   options: {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //   },
    // });
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  render() {
    const {
      percent,
      chartWidth,
      strokeWidth,
      strokeColor,
      displayBackgroundColor,
      fontWeight,
      percentLabel,
      icon,
      label,
    } = this.props;

    return (
      <div className="text-center alignCircleItems" style={{ padding: 0, width: 'fit-content' }}>
        <div className="alignDisplayOverCircle" style={{ width: 'fit-content' }}>
          <CirclePie
            strokeWidth={strokeWidth || 8}
            percent={percent}
            width={chartWidth}
            height={chartWidth}
            strokeColor={strokeColor || '#43425d'}
          />
          <div className="displayCircle" style={{ top: this.state.percentTop }}>
            <span
              className="some-text"
              style={{
                backgroundColor: displayBackgroundColor,
                fontSize: this.state.percentFontSize,
                fontWeight: fontWeight || '',
              }}
            >
              {percent}
            </span>
          </div>
          <div
            className="displayCircleSubHeading text-center"
            style={{
              fontSize: this.state.labelFontSize,
              top: this.state.percentLabelTop,
              fontWeight: 'lighter',
            }}
          >
            {percentLabel}
          </div>
        </div>

        {/* <div style={{ width: '200px', height: '200px', marginTop: '1rem' }}>
          <canvas id="doughnutChart" ref={this.chartRef} />
        </div> */}

        <h6 className="mt-2">
          {icon}
          <div
            className="text-center mt-2"
            style={{ color: '#43425D', fontSize: '.8rem' }}
          >
            {label}
          </div>
        </h6>
      </div>
    );
  }
}

export default PieChartNew;
